import { SafeCollector3ss0wp8n80f6m as SafeCollector } from './internal/SafeCollector.mjs';
import { $3l5vvh8yg0ier as $ } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from './FlowCollector.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { fuseSharedFlow3r8bpddms9npl as fuseSharedFlow } from './SharedFlow.mjs';
import {
  fuse$default2v3gehkaa3idr as fuse$default,
  FusibleFlow2tgh9s2p1kryd as FusibleFlow,
} from './internal/ChannelFlow.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwKotlinNothingValueException2lxmvl03dor6f as throwKotlinNothingValueException } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function asSharedFlow(_this__u8e3s4) {
  return new (ReadonlySharedFlow())(_this__u8e3s4, null);
}
function onSubscription(_this__u8e3s4, action) {
  return new (SubscribedSharedFlow())(_this__u8e3s4, action);
}
var SubscribedFlowCollectorClass;
function SubscribedFlowCollector() {
  if (SubscribedFlowCollectorClass === VOID) {
    class $_0 {
      constructor(collector, action) {
        this.w1f_1 = collector;
        this.x1f_1 = action;
      }
      *y1f($completion) {
        // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
        // Inline function 'kotlin.js.getCoroutineContext' call
        var tmp$ret$0 = $completion.qc();
        var safeCollector = new (SafeCollector())(this.w1f_1, tmp$ret$0);
        try {
          yield* $(this.x1f_1(safeCollector, $completion), $completion);
        }finally {
          safeCollector.ad();
        }
        var tmp = this.w1f_1;
        if (tmp instanceof SubscribedFlowCollector())
          yield* this.w1f_1.y1f($completion);
        return Unit_instance;
      }
      *q1e(value, $completion) {
        yield* this.w1f_1.q1e(value, $completion);
        return Unit_instance;
      }
    }
    initMetadataForClass($_0, 'SubscribedFlowCollector', VOID, VOID, [FlowCollector()], [0, 1]);
    SubscribedFlowCollectorClass = $_0;
  }
  return SubscribedFlowCollectorClass;
}
var ReadonlySharedFlowClass;
function ReadonlySharedFlow() {
  if (ReadonlySharedFlowClass === VOID) {
    class $ {
      constructor(flow, job) {
        this.f1i_1 = flow;
        this.g1i_1 = job;
      }
      f1e(context, capacity, onBufferOverflow) {
        return fuseSharedFlow(this, context, capacity, onBufferOverflow);
      }
      *u1f(collector, $completion) {
        yield* this.f1i_1.u1f(collector, $completion);
        throwKotlinNothingValueException();
      }
      t1d(collector, $completion) {
        return this.u1f(collector, $completion);
      }
    }
    protoOf($).g1e = fuse$default;
    initMetadataForClass($, 'ReadonlySharedFlow', VOID, VOID, [FusibleFlow()], [1]);
    ReadonlySharedFlowClass = $;
  }
  return ReadonlySharedFlowClass;
}
var SubscribedSharedFlowClass;
function SubscribedSharedFlow() {
  if (SubscribedSharedFlowClass === VOID) {
    class $ {
      constructor(sharedFlow, action) {
        this.h1i_1 = sharedFlow;
        this.i1i_1 = action;
      }
      *u1f(collector, $completion) {
        yield* this.h1i_1.u1f(new (SubscribedFlowCollector())(collector, this.i1i_1), $completion);
        return throwKotlinNothingValueException();
      }
      t1d(collector, $completion) {
        return this.u1f(collector, $completion);
      }
    }
    initMetadataForClass($, 'SubscribedSharedFlow', VOID, VOID, VOID, [1]);
    SubscribedSharedFlowClass = $;
  }
  return SubscribedSharedFlowClass;
}
//region block: exports
export {
  SubscribedFlowCollector as SubscribedFlowCollector17ch8by19noql,
  asSharedFlow as asSharedFlow2buz3fbrowsyg,
  onSubscription as onSubscription3iwvbdmbwg7iq,
};
//endregion

//# sourceMappingURL=Share.mjs.map
